// extracted by mini-css-extract-plugin
export var clauseRow = "_fn-6";
export var emptyState = "_fn-d";
export var filterContent = "_fn-a";
export var filterGroup = "_fn-1";
export var filterGroupContainer = "_fn-0";
export var nestedGroup = "_fn-2";
export var nestedGroupContent = "_fn-b";
export var nestedGroupDepth1 = "_fn-3";
export var nestedGroupDepth2 = "_fn-4";
export var nestedGroupDepth3 = "_fn-5";
export var nestedGroupEmpty = "_fn-c";
export var operatorAnd = "_fn-8";
export var operatorOr = "_fn-9";
export var operatorToggle = "_fn-7";
export var removeGroupButton = "_fn-e";